import { default as _91slug_93w9SuqBU4ABMeta } from "/vercel/path0/src/layers/web/pages/tourleader/[id]/[slug].vue?macro=true";
import { default as _91slug_93xQyvqYBEL1Meta } from "/vercel/path0/src/layers/web/pages/titinerary/[slug].vue?macro=true";
import { default as _91name_93LxLTK8bSR3Meta } from "/vercel/path0/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91paxid_93I9CPJYJ83pMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue?macro=true";
import { default as _91id_93BkMsEzIWNcMeta } from "/vercel/path0/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91id_93WO6U23xG9wMeta } from "/vercel/path0/src/layers/web/pages/omdome/[id].vue?macro=true";
import { default as _91tab_93SFkzWD1IPcMeta } from "/vercel/path0/src/layers/web/pages/mytrip/[tab].vue?macro=true";
import { default as _91tab_93m9pAUVsWaMMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue?macro=true";
import { default as _91tab_93EWJ5qmJAfbMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue?macro=true";
import { default as _91tab_93L2sKu5ns8ZMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue?macro=true";
import { default as _91tab_93nfH6f1YQCuMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/about/[tab].vue?macro=true";
import { default as _91slug_93Pkl1aWS9y6Meta } from "/vercel/path0/src/layers/web/pages/info/[slug].vue?macro=true";
import { default as _91id_93saqVB3evdNMeta } from "/vercel/path0/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as _91tab_93lkld7LdzR4Meta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue?macro=true";
import { default as _91slug_93ANe80eY3q7Meta } from "/vercel/path0/src/layers/web/pages/competition/[slug].vue?macro=true";
import { default as _91slug_93Q7JSZEeKMtMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/category/[slug].vue?macro=true";
import { default as _91ocr_93zFrzyfFoHhMeta } from "/vercel/path0/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91ocr_931PSLLD15cvMeta } from "/vercel/path0/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91id_93jBpePlIkBIMeta } from "/vercel/path0/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripid_93DZi91gfyteMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue?macro=true";
import { default as _91step_93JY83fR1lUZMeta } from "/vercel/path0/src/layers/web/pages/book/[tripid]/[step].vue?macro=true";
import { default as _91slug_930JECKLZ6YXMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/auth/[slug].vue?macro=true";
import { default as _91jwt_93HscmNMASFLMeta } from "/vercel/path0/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91tab_93FkxHqdWaBTMeta } from "/vercel/path0/src/layers/web/pages/[triptype]/[slug]/[tab].vue?macro=true";
import { default as indexVP2D3llIXDMeta } from "/vercel/path0/src/layers/web/pages/app/index.vue?macro=true";
import { default as callbackfBGP8njEuTMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/auth/callback.vue?macro=true";
import { default as blackweekY5TysoTDKCMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/blackweek.vue?macro=true";
import { default as _91slug_93oLstYFjwsaMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/blog/[slug].vue?macro=true";
import { default as indexD8OukSm09JMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/blog/index.vue?macro=true";
import { default as bookcallftq0TMhAnHMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/bookcall.vue?macro=true";
import { default as byebyeiegB9BkJKdPhMeta } from "/vercel/path0/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as indexs7C8mYfhG6Meta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/calendar/index.vue?macro=true";
import { default as lastminuteXdbpLkqFBUMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue?macro=true";
import { default as _91name_93RHC2DkaPfIMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/campaign/[name].vue?macro=true";
import { default as indexSnxVJyDITrMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/campaign/index.vue?macro=true";
import { default as catalogueaZEhkZRN7lMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/catalogue.vue?macro=true";
import { default as complaintSorDovy8zQMeta } from "/vercel/path0/src/layers/web/pages/complaint.vue?macro=true";
import { default as dinbokning_45aktuelliaIHExh2vSMeta } from "/vercel/path0/src/layers/web/pages/dinbokning-aktuell.vue?macro=true";
import { default as _91slug_93yyGXeNIkilMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/event/[slug].vue?macro=true";
import { default as indexuXjEOW7WsQMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/event/index.vue?macro=true";
import { default as faqu4dseP687NMeta } from "/vercel/path0/src/layers/web/pages/faq.vue?macro=true";
import { default as indexdiOqrgCSTTMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/flights/index.vue?macro=true";
import { default as search1viMjYZbMUMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/flights/search.vue?macro=true";
import { default as _91id_93SOylqa3BNiMeta } from "/vercel/path0/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as index8Rff2io75zMeta } from "/vercel/path0/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91name_93ZeKqRX1v56Meta } from "/vercel/path0/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as index77YsBsNO6ZMeta } from "/vercel/path0/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as indextTce3SxunZMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/index.vue?macro=true";
import { default as indexQWC1UrfX86Meta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/group/index.vue?macro=true";
import { default as grouptravel2hAt97lAb5Meta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/grouptravel.vue?macro=true";
import { default as indexcIzu2HwKlPMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/index.vue?macro=true";
import { default as reviewsEVH6kmkyAjMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/info/reviews.vue?macro=true";
import { default as lastminuteChzPgxEsxJMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/lastminute.vue?macro=true";
import { default as mapTtP01Z8asLMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/map.vue?macro=true";
import { default as dinbokningDtC0FoG9sQMeta } from "/vercel/path0/src/layers/web/pages/mytrip/dinbokning.vue?macro=true";
import { default as newsletterCyDCXA03PrMeta } from "/vercel/path0/src/layers/web/pages/newsletter.vue?macro=true";
import { default as offlineRawgwBLaBbMeta } from "/vercel/path0/src/layers/web/pages/offline.vue?macro=true";
import { default as failed2cfHJXvWVtMeta } from "/vercel/path0/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as index6ND441yvjmMeta } from "/vercel/path0/src/layers/web/pages/review/index.vue?macro=true";
import { default as risrosImLVa0pKikMeta } from "/vercel/path0/src/applications/rolfsbuss-web/pages/risros.vue?macro=true";
import { default as searchXXOrLnsR0qMeta } from "/vercel/path0/src/layers/web/pages/search.vue?macro=true";
import { default as indexR51gAxeeorMeta } from "/vercel/path0/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as verification_45donePjxg97AiBBMeta } from "/vercel/path0/src/layers/web/pages/verification-done.vue?macro=true";
export default [
  {
    name: "tourleader-id",
    path: "/guider/:id()",
    component: () => import("/vercel/path0/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "titinerary",
    path: "/dagsprogram",
    component: () => import("/vercel/path0/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "shipinfo",
    path: "/skib",
    component: () => import("/vercel/path0/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "satisfactionstatus-triptypeid",
    path: "/tilfredshed-status/:triptypeid()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/vercel/path0/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "omdome",
    path: "/omdome",
    component: () => import("/vercel/path0/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "mytrip",
    path: "/din-rejse",
    component: () => import("/vercel/path0/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "info-solo",
    path: "/info/solo",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "info-lectures",
    path: "/info/foredrag",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-connections",
    path: "/info/forbindelser",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-about",
    path: "/info/om",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/vercel/path0/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "fn",
    path: "/fn",
    component: () => import("/vercel/path0/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "destination-slug",
    path: "/destination/:slug()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "competition",
    path: "/konkurrence",
    component: () => import("/vercel/path0/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "category",
    path: "/kategori",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    component: () => import("/vercel/path0/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    component: () => import("/vercel/path0/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    component: () => import("/vercel/path0/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "bookflight",
    path: "/bookflight",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "book-tripid",
    path: "/bestil/:tripid()",
    component: () => import("/vercel/path0/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "auth",
    path: "/medlem",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    component: () => import("/vercel/path0/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "triptype-slug",
    path: "/:triptype()/:slug()",
    component: () => import("/vercel/path0/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "triptype-slug-tab",
    path: "/:triptype()/:slug()/:tab()",
    meta: _91tab_93FkxHqdWaBTMeta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/vercel/path0/src/layers/web/pages/app/index.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/vercel/path0/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "auth-slug",
    path: "/medlem/:slug()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "auth-callback",
    path: "/medlem/callback",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/auth/callback.vue")
  },
  {
    name: "blackweek",
    path: "/blackweek",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/blackweek.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "book-tripid-step",
    path: "/bestil/:tripid()/:step()",
    component: () => import("/vercel/path0/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "bookcall",
    path: "/boka-samtal",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/bookcall.vue")
  },
  {
    name: "bookflight-tripid",
    path: "/bookflight/:tripid()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/vercel/path0/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/vercel/path0/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    component: () => import("/vercel/path0/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/vercel/path0/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "calendar",
    path: "/kalender",
    meta: indexs7C8mYfhG6Meta || {},
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/calendar/index.vue")
  },
  {
    name: "calendar-lastminute",
    path: "/kalender/afbudsrejser",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue")
  },
  {
    name: "campaign-name",
    path: "/kampagne/:name()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/campaign/[name].vue")
  },
  {
    name: "campaign",
    path: "/kampagne",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/campaign/index.vue")
  },
  {
    name: "catalogue",
    path: "/katalog",
    meta: catalogueaZEhkZRN7lMeta || {},
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/catalogue.vue")
  },
  {
    name: "category-slug",
    path: "/kategori/:slug()",
    meta: _91slug_93Q7JSZEeKMtMeta || {},
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "competition-slug",
    path: "/konkurrence/:slug()",
    component: () => import("/vercel/path0/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "complaint",
    path: "/reklamation",
    meta: complaintSorDovy8zQMeta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/complaint.vue")
  },
  {
    name: "destination-slug-tab",
    path: "/destination/:slug()/:tab()",
    meta: _91tab_93lkld7LdzR4Meta || {},
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "dinbokning-aktuell",
    path: "/dinbokning-aktuell",
    component: () => import("/vercel/path0/src/layers/web/pages/dinbokning-aktuell.vue")
  },
  {
    name: "event-slug",
    path: "/event/:slug()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/event/[slug].vue")
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/event/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/vercel/path0/src/layers/web/pages/faq.vue")
  },
  {
    name: "flights",
    path: "/flights",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/flights/index.vue")
  },
  {
    name: "flights-search",
    path: "/flights/search",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/flights/search.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    component: () => import("/vercel/path0/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "giftcard-id",
    path: "/gavekort/:id()",
    component: () => import("/vercel/path0/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "giftcard",
    path: "/gavekort",
    component: () => import("/vercel/path0/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "hotels-name",
    path: "/hoteller/:name()",
    meta: _91name_93ZeKqRX1v56Meta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "hotels",
    path: "/hoteller",
    component: () => import("/vercel/path0/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug()",
    meta: _91slug_93Pkl1aWS9y6Meta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "info-about-tab",
    path: "/info/om/:tab()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info-connections-tab",
    path: "/info/forbindelser/:tab()",
    meta: _91tab_93L2sKu5ns8ZMeta || {},
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-group",
    path: "/info/group",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/group/index.vue")
  },
  {
    name: "info-grouptravel",
    path: "/info/grupperejse",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/grouptravel.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/index.vue")
  },
  {
    name: "info-lectures-tab",
    path: "/info/foredrag/:tab()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-reviews",
    path: "/info/reviews",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/reviews.vue")
  },
  {
    name: "info-solo-tab",
    path: "/info/solo/:tab()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/info/solo/[tab].vue")
  },
  {
    name: "lastminute",
    path: "/afbudsrejser",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/lastminute.vue")
  },
  {
    name: "map",
    path: "/kort",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/map.vue")
  },
  {
    name: "mytrip-tab",
    path: "/din-rejse/:tab()",
    meta: _91tab_93SFkzWD1IPcMeta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "mytrip-dinbokning",
    path: "/mytrip/dinbokning",
    component: () => import("/vercel/path0/src/layers/web/pages/mytrip/dinbokning.vue")
  },
  {
    name: "newsletter",
    path: "/nyhedsbrev",
    component: () => import("/vercel/path0/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/vercel/path0/src/layers/web/pages/offline.vue")
  },
  {
    name: "omdome-id",
    path: "/omdome/:id()",
    meta: _91id_93WO6U23xG9wMeta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/vercel/path0/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/vercel/path0/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "review",
    path: "/bedom-rejse",
    component: () => import("/vercel/path0/src/layers/web/pages/review/index.vue")
  },
  {
    name: "risros",
    path: "/risros",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/risros.vue")
  },
  {
    name: "satisfactionstatus-triptypeid-paxid",
    path: "/tilfredshed-status/:triptypeid()/:paxid()",
    component: () => import("/vercel/path0/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "search",
    path: "/sog",
    component: () => import("/vercel/path0/src/layers/web/pages/search.vue")
  },
  {
    name: "shipinfo-name",
    path: "/skib/:name()",
    meta: _91name_93LxLTK8bSR3Meta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "titinerary-slug",
    path: "/dagsprogram/:slug()",
    component: () => import("/vercel/path0/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "tourleader-id-slug",
    path: "/guider/:id()/:slug()",
    component: () => import("/vercel/path0/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "tourleader",
    path: "/guider",
    component: () => import("/vercel/path0/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45donePjxg97AiBBMeta || {},
    component: () => import("/vercel/path0/src/layers/web/pages/verification-done.vue")
  }
]